import * as end from '../constants/api'
import { axiosInstance } from './axios-instance'

const NotificationsService = {
	postToken: ({ payload, userId }) => {
		payload.device = navigator.platform
		return axiosInstance.post(end.notification({ userId }), payload).then(res => res.data)
	},
	getNotificationsConfig: ({ email, userId }) => {
		const routeEmail = email ? `?email=${encodeURIComponent(email)}` : ''
		return axiosInstance
			.get(`${end.notificationsConfig({ userId })}` + routeEmail)
			.then(res => res.data)
	},
	updateNotificationConfig: ({ payload, userId }) =>
		axiosInstance.put(end.notificationsConfig({ userId }), payload).then(res => res.data),
	getNotifications: ({ email, userId }) => {
		const routeEmail = email ? `?email=${encodeURIComponent(email)}` : ''
		return axiosInstance.get(end.notifications({ userId }) + routeEmail).then(res => res.data)
	},
	updateNotificationSeen: ({ payload, userId, notificationId }) =>
		axiosInstance
			.put(end.notifications({ userId }) + `?notificationId=${notificationId}`, payload)
			.then(res => res.data)
}

export default NotificationsService
